import { action, observable, makeObservable } from 'mobx';
import { RemoteResourceV3, updateRemoteResourceV3 } from '../../../../commonv3/api/RemoteResourceV3';
import { PagedList } from '../../../../admin/types/pagination';
import { LessonHomeworkSubmissionIndexView } from '../../../types/lesson_homework_submissions';
import { UrlBoundParam } from '../../../../commonv3/states/UrlBoundParam';
import { UserCourseWorkSubmissionApis } from '../../../apis/userCourseWorkSubmissions';

export class CourseWorkSubmissionListState {
  page = UrlBoundParam.integerParam('page', 1);
  submissions: RemoteResourceV3<PagedList<LessonHomeworkSubmissionIndexView>> = RemoteResourceV3.loading();

  constructor() {
    makeObservable(this, {
      page: observable,
      submissions: observable,
      init: action.bound,
      setPage: action.bound,
    });
  }

  async init() {
    await updateRemoteResourceV3(
      this.submissions,
      (v) => (this.submissions = v),
      () => UserCourseWorkSubmissionApis.findAll(this.page.get())
    );
  }

  async setPage(page) {
    this.page.set(page);
    await this.init();
  }
}
